import { render, staticRenderFns } from "./HackernewsTrending.vue?vue&type=template&id=a2d69098&scoped=true"
import script from "./HackernewsTrending.vue?vue&type=script&lang=js"
export * from "./HackernewsTrending.vue?vue&type=script&lang=js"
import style0 from "./HackernewsTrending.vue?vue&type=style&index=0&id=a2d69098&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d69098",
  null
  
)

export default component.exports